// extracted by mini-css-extract-plugin
module.exports = {"stylus":"App_stylus__1pfsy"};